// Common method for ajax request.
// options:
// type: default to GET
// contentType: default to application/json
// Changes made here to headers or header logic also need to be applied to appInit.modifiedSync.

const authMgr = require('app/authMgr');
const constants = require('shared/helpers/constants');

const send = function (options) {
    _.extend(options, {
        beforeSend: function (xhr, settings) {
            xhr.setRequestHeader('welldrive-client-version', constants.wellDriveVersion);
            xhr.setRequestHeader('Authorization', authMgr.getAuthHeader());
        },
    });
    let promise = $.ajax({
        type: 'GET',
        contentType: 'application/json',
        ...options
    });
    promise.done((data, status, xhr) => {
        if (xhr.getResponseHeader('web-client-reload') && xhr.getResponseHeader('web-client-reload') === 'true') {
            window.location.reload(true);
        }
    });
    return promise;
}

module.exports = send;